import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsappFab } from "@/components/WhatsappFab";
import { HeroV2 } from "@/components/landing/HeroV2";
import { Seo } from "@/components/Seo";
import { orgSchema, websiteSchema, localBusinessSchema, faqPageSchema, howToSchema } from "@/lib/seo-schemas";
import { KEYWORDS_HOME } from "@/lib/seo-keywords";

// Lazy-load below-the-fold sections
const TrustStrip = lazy(() => import("@/components/landing/TrustStrip").then(m => ({ default: m.TrustStrip })));
const ServicesGrid = lazy(() => import("@/components/landing/ServicesGrid").then(m => ({ default: m.ServicesGrid })));
const PacksSection = lazy(() => import("@/components/landing/PacksSection").then(m => ({ default: m.PacksSection })));
const ProcessTimeline = lazy(() => import("@/components/landing/ProcessTimeline").then(m => ({ default: m.ProcessTimeline })));
const FounderPromise = lazy(() => import("@/components/landing/FounderPromise").then(m => ({ default: m.FounderPromise })));
const FAQ = lazy(() => import("@/components/landing/FAQ").then(m => ({ default: m.FAQ })));
const FinalCta = lazy(() => import("@/components/landing/FinalCta").then(m => ({ default: m.FinalCta })));

const Index = () => {
  const { i18n, t } = useTranslation("landing");
  const isAr = i18n.language?.startsWith("ar");
  const title = isAr
    ? "Conceptions.ma — لافطات وملفات CNC جاهزة"
    : "Conceptions.ma — Dossiers enseigne & fichiers CNC Maroc";
  const description = isAr
    ? "دوسيات كاملة ديال اللافطات، ملفات قصّ CNC مقبولة من اللولة، هويات بصرية وپاكات حرفية. كازا والمغرب كامل، من 49 درهم."
    : "Dossiers enseigne complets, fichiers CNC acceptés du premier coup, identités visuelles et packs métiers. Maroc, dès 49 DH.";

  const faqItems = (t("faq.items", { returnObjects: true }) as { q: string; a: string }[]) ?? [];

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Seo
        title={title}
        description={description}
        path="/"
        keywords={KEYWORDS_HOME}
        jsonLd={[
          orgSchema(),
          websiteSchema(),
          localBusinessSchema(),
          faqPageSchema(faqItems),
          howToSchema(),
        ]}
      />
      <Header />
      <main className="flex-1">
        <HeroV2 />
        <Suspense fallback={null}>
          <TrustStrip />
          <ServicesGrid />
          <PacksSection />
          <ProcessTimeline />
          <FounderPromise />
          <FAQ />
          <FinalCta />
        </Suspense>
      </main>
      <Footer />
      <WhatsappFab />
    </div>
  );
};

export default Index;
